import React from "react";
import { Stepper } from "../../../utils/general";
import SetPhone from "./setPhone";
import VerifyPhone from "./verifyPhone";
import SignUp from "./register/index";

function SignIn() {
  return <Stepper components={[SetPhone, VerifyPhone, SignUp]}></Stepper>;
}
export default SignIn;
